import axios from 'axios';

export default {
  fetchDashboards(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/dashboards",)
      .then(results=>{
        return results.data;
      })
  },
  bulkUpdate(dashboardsToUpdate){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/dashboards",dashboardsToUpdate)
      .then(results=>{
        return results.data;
      })
  },
  post(dasboardToCreate){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/dashboards",dasboardToCreate)
      .then(results=>{
        return results.data;
      })
  },
  delete(id){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/dashboards/"+id);
  }
}
